import { LotTranslation } from '../../../graphql/service/graphql-auto-main-service';

export type Lang = 'ru' | 'en';

export enum TranslationTypeEnum {
  AUTO = 'AUTO',
  AI = 'AI',
  MANUAL = 'MANUAL',
}

export type TranslationLangGroup = {
  lang: Lang;
  text: LotTranslation[];
  voice: LotTranslation[];
};

export type TranslationTypePanel = {
  header: string;
  active: boolean;
  type: TranslationTypeEnum;
  langs: TranslationLangGroup[];
};
